module.exports = __webpack_public_path__ + "static/media/ladder.4bb8d01e.png";